export default {
  flex: {
    display: 'flex',
  },
  wrapper: {
    justifyContent: 'space-between',
    padding: '12px',
    width: '100%',
  },
}
